import { render, staticRenderFns } from "./ProjectIntegrationConversation.vue?vue&type=template&id=78e3e4f5"
import script from "./ProjectIntegrationConversation.vue?vue&type=script&lang=ts"
export * from "./ProjectIntegrationConversation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports